/** @format */

import React, { useState, useEffect } from 'react';

import { Modal, Col, Row, Button, Card } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, FileTwoTone, FilePdfTwoTone } from '@ant-design/icons';
import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import ButtonActionsRecipe from './components/ButtonActionsRecipe';
import EditRutOrRecipe from './components/EditRutOrRecipe';
import Rut from './components/Rut';
import ActionsDone from './components/ActionsDone';

import { serviceApproveByQf } from './services';

import './style.css';
const APP_COUNTRY = process.env.REACT_APP___COUNTRY;

export default function Recipe(props) {
	const [modal, setModal] = useState(false);
	const [approveQf, setApproveQf] = useState({});
	const [dataUser, setDataUser] = useState(null);

	useEffect(() => {
		setDataUser(GetLocalStorageValue(LOCAL_STORAGE.USER));
		serviceApproveByQf({
			rut: props.order.info.rut,
			code_internal: props.product.code_internal,
			pharmacy: props.pharmacy,
		}).then((response) => setApproveQf(response));
		return () => {};
	}, [props.order.info.rut, props.product.code_internal, props.pharmacy]);

	if (dataUser === null) {
		return <>Cargando...</>;
	}

	if (dataUser !== null) {
		return (
			<>
				<Button type="primary" shape="circle" icon={<FileTwoTone />} onClick={() => setModal(true)} className={'ph-recipe-button'} />
				<Modal centered visible={modal} onCancel={() => setModal(false)} footer={null} width="900px">
					<div className="ph-recipe-modal-global-container">
						<Row gutter={12} className="ph-recipe-modal-container">
							<Col span={12} className="ph-recipe-modal-main-container">
								<Card
									bordered={false}
									cover={<img alt={props.product.editable_name} src={props.product.image} className="ph-recipe-modal-img" />}
								></Card>
								<Card.Meta
									className="ph-recipe-modal-product-link-container"
									title={props.product.editable_name}
									description={
										<a
											href={`${process.env.REACT_APP_BASE}/products/${props.product.slug}`}
											target="_blank"
											rel="noopener noreferrer"
											className="ph-recipe-modal-product-link"
										>
											Ver el producto
										</a>
									}
								/>
							</Col>
							{(dataUser.rols.indexOf('admin') >= 0 && props.status !== 101) ||
							dataUser.rols.indexOf('qf-pharol') >= 0 ||
							dataUser.rols.indexOf('qf-external') >= 0 ||
							(props.pharmacy !== 'general' && dataUser.rols.indexOf(`tracking-${props.pharmacy}`)) ||
							(props.pharmacy !== 'general' && dataUser.rols.indexOf(`admin-${props.pharmacy}`)) ? (
								<Col span={12} className="ph-recipe-modal-inner-container">
									<div>
										<h1 className="ph-recipe-modal-inner-container-title">Acciones Disponibles:</h1>
										<div className="ph-recipe-modal-buttons-actions-container ph-recipe-modal-buttons-actions">
											{props.product.validation_product !== 'RA' && (
												<ButtonActionsRecipe
													labelName="Aprobar Receta"
													handleAcceptOrRejectRecipe={props.handleAcceptOrRejectRecipe}
													setModal={setModal}
													icon={<CheckCircleOutlined />}
													danger={false}
													trx_id={props.order.trx_id}
													code_internal={props.product.code_internal}
													status="RA"
												/>
											)}
											{props.product.validation_product !== 'RI' && (
												<ButtonActionsRecipe
													labelName="Rechazar Receta"
													handleAcceptOrRejectRecipe={props.handleAcceptOrRejectRecipe}
													setModal={setModal}
													icon={<CloseCircleOutlined />}
													danger={true}
													trx_id={props.order.trx_id}
													code_internal={props.product.code_internal}
													invalidRecipeReasons={props.invalidRecipeReasons}
													status="RI"
												/>
											)}
											{props.product.validation_product !== 'RA' && APP_COUNTRY !== 'AR' && (
												<ButtonActionsRecipe
													labelName="Aprobado bajo criterio del QF"
													handleAcceptOrRejectRecipe={props.handleAcceptOrRejectRecipe}
													setModal={setModal}
													icon={<CheckCircleOutlined />}
													danger={false}
													trx_id={props.order.trx_id}
													code_internal={props.product.code_internal}
													status="RA-QF"
												/>
											)}
										</div>
									</div>
								</Col>
							) : null}
						</Row>
						<Row gutter={12} className="ph-recipe-modal-container">
							<Col span={12}>
								<Card
									bordered={false}
									cover={
										/.pdf/.test(props.product.recipe) ? (
											<FilePdfTwoTone style={{ fontSize: '110px' }} twoToneColor="#F40F02" />
										) : (
											<img alt="Recipe del Producto" src={props.product.recipe} className="ph-recipe-modal-img-recipe" />
										)
									}
								></Card>
								<Card.Meta
									className="ph-recipe-modal-product-link-container"
									description={
										<a
											href={props.product.recipe}
											target="_blank"
											rel="noopener noreferrer"
											className="ph-recipe-modal-product-link"
										>
											Ver receta
										</a>
									}
								/>
							</Col>
							<Col span={12} className="ph-recipe-modal-inner-container">
								{(dataUser.rols.indexOf('pharol-qf') >= 0 || dataUser.rols.indexOf('admin') >= 0) && APP_COUNTRY !== 'AR' && (
									<div>
										<h1 className="ph-recipe-modal-inner-container-title">Acciones Disponibles:</h1>
										<div className="ph-recipe-modal-buttons-actions-container">
											<EditRutOrRecipe
												product={props.product}
												type="Recipe"
												handleEditRutOrRecipe={props.handleEditRutOrRecipe}
											/>
										</div>
									</div>
								)}
							</Col>
						</Row>
						<Row gutter={12} className="ph-recipe-modal-container">
							<Col span={12}>
								{props.product.rut && <Rut product={props.product} handleEditRutOrRecipe={props.handleEditRutOrRecipe} />}
								{props.product.validation_product && <ActionsDone product={props.product} reject />}
								{approveQf.data?.length > 0 && <ActionsDone approveQf={approveQf.data} />}
							</Col>
						</Row>
					</div>
				</Modal>
			</>
		);
	}
}
